/******************************************************************
 * Archivo : client/src/queries/fetchViewerUsers.js
 * Proyecto: CB30
 *
 * Consulta GraphQL - Visor Universal
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query ViewerUsersQuery {
    viewerUsers {
      id
      nombre
      apellido
      email

      surveys {
        surveyId
        surveyResultsId
        titulo
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchViewerUsers.js